<template>
  <SvgIcon v-if="roomId && deviceType" icon-class="device-connect" />
  <SvgIcon v-else-if="!roomId && deviceType === 5" icon-class="device-web" />
  <SvgIcon v-else-if="!roomId && (deviceType === 1 || deviceType === 3)" icon-class="device-phone" />
  <SvgIcon v-else-if="!roomId && deviceType === 4" icon-class="device-computer" />
  <SvgIcon v-else-if="!roomId && deviceType" icon-class="device-glasses" />
</template>
<script>
/*
ANDROID = 1
IOS     = 3
WINDOWS = 4
WEB     = 5
GLASSES = 0 | 2 | 6 | 7 | 8 | 9 | ...
Normal  = ''
*/
export default {
  name: 'DeviceType',
  props: {
    deviceType: {
      type: [Number, String],
      default: ''
    },
    roomId: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.svg-icon{
  vertical-align: middle!important;
  margin-top: 0!important;
  margin-left: 8px;
}
</style>
